import { FC } from 'react';

import { Box, Typography } from '@mui/material';
import { useAppSelector } from 'hooks';
import ResultDoughnut from 'portfolio3/components/common/ResultDoughnut';
import { MarkType } from 'portfolio3/features/performance';
import { NeutralColors } from 'portfolio3/styles';
import { activeFormatSelector } from 'selectors/drawers';

import * as styles from './styles';

interface ISubject {
  name: string;
  result?: number;
  nonMarkValue?: string;
}

interface IPerformanceYearCardProps {
  averageResult: number;
  subjects: ISubject[];
  markType?: MarkType;
  isOld?: boolean;
}

const PerformanceYearCard: FC<IPerformanceYearCardProps> = ({ averageResult, subjects, markType, isOld = false }) => {
  const format = useAppSelector(activeFormatSelector);
  return (
    <Box className="performance-year-card">
      {(isOld || markType === MarkType.AVERAGE) && (
        <Box className="performance-year-card__average pdf-keep" sx={styles.averageCard}>
          <ResultDoughnut
            size={80}
            progressColor={NeutralColors.night_neutrals_600}
            trackColor={NeutralColors.night_neutrals_900}
            value={averageResult}
            maxValue={5}
            typographyVariant="Headings/H4"
          />
          <Typography variant="Headings/H5">Средний балл по всем предметам</Typography>
        </Box>
      )}

      <Box className="performance-year-card__subjects" sx={styles.subjects(format)}>
        {subjects.map((subject) => {
          return (
            <Box key={subject.name} className="performance-year-card__subject pdf-keep" sx={styles.subjectCard}>
              <ResultDoughnut
                size={60}
                progressColor={NeutralColors.night_neutrals_600}
                trackColor={NeutralColors.night_neutrals_900}
                value={subject.result ?? null}
                altValue={subject.nonMarkValue}
                maxValue={5}
                typographyVariant="Paragraph LG/Semi Bold"
              />
              <Typography variant="Paragraph LG/Regular">{subject.name}</Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default PerformanceYearCard;
